import * as React from 'react';
import type { SVGProps } from 'react';

const EyeSvg = ({ width = 17, height = 16, fill = '#616061', ...props }: SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.5 8L3.57945 4.30466C4.79638 2.84434 6.59909 2 8.5 2C10.4009 2 12.2036 2.84434 13.4206 4.30466L16.5 8L13.4206 11.6953C12.2036 13.1557 10.4009 14 8.5 14C6.59909 14 4.79638 13.1557 3.57945 11.6953L0.5 8ZM8.5 11C10.1569 11 11.5 9.65685 11.5 8C11.5 6.34315 10.1569 5 8.5 5C6.84315 5 5.5 6.34315 5.5 8C5.5 9.65685 6.84315 11 8.5 11Z" fill={fill}/>
  </svg>
);

export default EyeSvg; 